import SVGIconWrapper from "./SVGIconWrapper"

const IconStarFilled = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--star-filled ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M249.2 384.5L94.6 482.2 142 308.5-1 195.2l183.9-9.7 66.3-167.7 66.3 167.7 183.9 9.7-143 113.3 47.4 173.7-154.6-97.7z" />
    </SVGIconWrapper>
)

export default IconStarFilled